import { useState } from "react";
import { useNavigate, Navigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, Lock } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth, formatApiErrorDetail } from "@/context/AuthContext";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email.trim(), password);
      toast.success("Welcome back");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-brand-dark grain px-4">
      <div className="absolute inset-0 dot-grid opacity-[0.08]" />
      <div className="relative w-full max-w-md">
        <Link to="/" className="flex justify-center mb-8">
          <img src="/logo-white.png" alt="SML Municipal Consulting" className="h-12 w-auto" />
        </Link>
        <div className="bg-white rounded-2xl shadow-2xl p-8">
          <div className="flex items-center gap-2.5 mb-1">
            <span className="flex items-center justify-center w-9 h-9 rounded-lg bg-primary/5 text-secondary"><Lock className="w-4 h-4" /></span>
            <h1 className="font-heading text-xl font-semibold text-primary">Team Sign In</h1>
          </div>
          <p className="text-sm text-muted-foreground mb-6">Access the enquiries dashboard.</p>
          <form onSubmit={submit} data-testid="login-form" className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="email" className="text-sm font-medium text-slate-700">Email</Label>
              <Input id="email" type="email" data-testid="login-email" value={email} onChange={(e) => setEmail(e.target.value)}
                placeholder="you@smlmunicipalconsulting.co.za" className="bg-slate-50 h-12" required />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password" className="text-sm font-medium text-slate-700">Password</Label>
              <Input id="password" type="password" data-testid="login-password" value={password} onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••" className="bg-slate-50 h-12" required />
            </div>
            <button type="submit" disabled={loading} data-testid="login-submit"
              className="w-full inline-flex items-center justify-center gap-2 bg-primary text-white font-semibold rounded-full py-3.5 hover:bg-primary/90 disabled:opacity-70 transition-all">
              {loading ? <><Loader2 className="w-4 h-4 animate-spin" /> Signing in…</> : "Sign In"}
            </button>
          </form>
        </div>
        <Link to="/" className="block text-center mt-6 text-sm text-white/60 hover:text-white transition-colors">← Back to website</Link>
      </div>
    </div>
  );
}
